module.exports = __webpack_public_path__ + "static/media/Kidify.0fc1d756.png";